import _extends from "@babel/runtime/helpers/extends";
import { ReloadIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { withOnMountHandler } from "../../../../../../../../../utils/withOnMountHandler";
import withEnterKeyHandler from "../../../../../../../../../utils/withOnEnterKeyHandler";
import { Input } from "../../../../../../../../../components/Input";
import { getWindow } from "../../../../../../../../../utils/window";
import { ymPushParams } from "../../../../../../../../../utils/ym.alternative";
import { getAccountType } from "../../../../../../../../../utils/analytics";
import styles from "./styles.pcss";
import { ECaptchaConstant } from "../constants";
import { getAnalyticsConverter } from "./analytics";
var cx = classNames.bind(styles);
var EnhancedInput = compose(withDataConverter(getAnalyticsConverter({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
})), withEnterKeyHandler)(Input);
export var CaptchaInput = withOnMountHandler(function (_ref) {
  var inputProps = _ref.inputProps,
    onRefresh = _ref.onRefresh,
    pic = _ref.pic;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper'),
    "data-t-id": "Captcha-CaptchaInput"
  }, /*#__PURE__*/React.createElement(EnhancedInput, _extends({}, inputProps, {
    error: inputProps.error
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, pic && /*#__PURE__*/React.createElement("img", {
    alt: "captcha",
    className: cx('image'),
    src: pic
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('reset')
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "".concat(ECaptchaConstant.RefreshButtonText),
    className: cx('refresh'),
    onClick: onRefresh,
    title: "".concat(ECaptchaConstant.RefreshButtonText),
    type: "button"
  }, /*#__PURE__*/React.createElement(ReloadIcon, null)))));
});